import useCountdown from 'ui/hooks/useCountdown';

interface CountdownTimerProps {
  targetDate: string | number;
  isUseHours?: boolean;
  textClassName?: string;
}

const CountdownTimer = ({
  targetDate,
  isUseHours = false,
  textClassName = 'text-sm font-semibold text-reliableBlack',
}: CountdownTimerProps) => {
  const [hours, minutes, seconds] = useCountdown(targetDate);

  if (hours + minutes + seconds <= 0) {
    return (
      <span className={textClassName ? textClassName : 'text-sm font-semibold text-reliableBlack'}>
        {isUseHours ? '00:00:00' : '00:00'}
      </span>
    );
  } else {
    return (
      <span className={textClassName ? textClassName : 'text-sm font-semibold text-reliableBlack'}>
        {isUseHours ? (
          <>
            <span>{hours < 10 ? `0${hours}` : `${hours}`}</span>
            <span>:</span>
          </>
        ) : null}
        <span>{minutes < 10 ? `0${minutes}` : `${minutes}`}</span>
        <span>:</span>
        <span>{seconds < 10 ? `0${seconds}` : `${seconds}`}</span>
      </span>
    );
  }
};

export default CountdownTimer;
